/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-11-26 11:34:56
 * @LastEditors: 诺
 * @LastEditTime: 2022-12-06 16:12:07
 * @Description: file content
 * requiresAuth 1静默授权 2用户授权  0无需授权
 */
import MyRouter from "@/routers/index";
import config from "./config";
let myRouter = new MyRouter({
  fake: config.env[process.env.VUE_APP_SERVE_ENV].routersActWxauth.fake,
  servicesActWxjssdk: config.env[process.env.VUE_APP_SERVE_ENV].servicesActWxjssdk,
});

myRouter.router.addRoutes([
  {
    path: "/layout",
    name: "layout",
    meta: {
      title: "",
      requiresAuth: 0,
    },
    component: () => import("./layout.vue"),
    children: [
      {
        path: "/index",
        name: "index",
        meta: {
          title: "假期来远洋，劲享超多好福利",
          requiresAuth: 2,
        },
        component: () => import("./index.vue"),
      },
      {
        path: "/lightup",
        name: "lightup",
        meta: {
          title: "点亮",
          requiresAuth: 2,
        },
        component: () => import("./lightup.vue"),
      },
      {
        path: "/luck/:id",
        name: "luck",
        meta: {
          title: "抽奖",
          requiresAuth: 2,
        },
        component: () => import("./luck.vue"),
      },
      {
        path: "/rule",
        name: "rule",
        meta: {
          title: "活动规则",
          requiresAuth: 2,
        },
        component: () => import("./rule.vue"),
      },
      {
        path: "/ranking",
        name: "ranking",
        meta: {
          title: "排行榜",
          requiresAuth: 2,
        },
        component: () => import("./ranking.vue"),
      },
      {
        path: "/prize",
        name: "prize",
        meta: {
          title: "我的奖品",
          requiresAuth: 2,
        },
        component: () => import("./prize.vue"),
      },
      {
        path: "/prize2",
        name: "prize2",
        meta: {
          title: "我的奖品",
          requiresAuth: 2,
        },
        component: () => import("./prize2.vue"),
      },
      {
        path: "/friends",
        name: "friends",
        meta: {
          title: "我的好友",
          requiresAuth: 2,
        },
        component: () => import("./friends.vue"),
      },
      {
        path: "/writeoff",
        name: "writeoff",
        meta: {
          title: "核销",
          requiresAuth: 1,
        },
        component: () => import("./writeoff.vue"),
      },
      {
        path: "/writeoff2",
        name: "writeoff2",
        meta: {
          title: "核销",
          requiresAuth: 1,
        },
        component: () => import("./writeoff2.vue"),
      },
      {
        path: "/coupon",
        name: "coupon",
        meta: {
          title: "优惠券",
          requiresAuth: 1,
        },
        component: () => import("./coupon.vue"),
      },
      {
        path: "/share",
        name: "share",
        meta: {
          title: "每日打卡",
          requiresAuth: 1,
        },
        component: () => import("./share.vue"),
      },
      {
        path: "/pay",
        name: "pay",
        meta: {
          title: "666元解锁六大礼",
          requiresAuth: 1,
        },
        component: () => import("./pay.vue"),
      },
      {
        path: "/live",
        name: "live",
        meta: {
          title: "直播",
          requiresAuth: 1,
        },
        component: () => import("./live.vue"),
      },
      {
        path: "/couponRule/:id",
        name: "couponRule",
        meta: {
          title: "优惠券规则",
          requiresAuth: 1,
        },
        component: () => import("./couponRule.vue"),
      },
    ],
  },
]);
export default myRouter.router;
